// Core
import { connect } from 'react-redux';
// Actions
import { setSelectionByKey } from '../../../../ducks/noShop/Methods';

import Component from './Component';

const mapStateToProps = state => ({
    selection: state.noShop.q4.selection,
});

const mapDispatchToProps = {
    setSelectionByKey,
};

const Q4 = connect(mapStateToProps, mapDispatchToProps)(Component);

export default Q4;